<div class="grid col-7">
    <div class="col-10" *ngIf="isHeaderShown">
        <p-message severity="info" text="{{titleHeader}}"></p-message>
    </div>
    <div class="col-1">
        <div *ngIf="isbrandLogoImageShown"><img class="center-block" [src]="brandLogoImage" /></div>
    </div>
</div>
